<h2 mat-dialog-title><fa-icon style="margin-right: .5rem" [icon]="'upload'"></fa-icon>Anhänge vom Computer hochladen</h2>
<mat-dialog-content>
    <div class="dropzone-container">
    <dropzone #dropzoneComp
        [config]="DropzoneConfig$ | async"
        [message]="'Klicken oder Dateien hinein ziehen'"
        (error)="OnUploadError($event)"
        (success)="OnUploadSuccess($event)"
        (addedFile)="OnAddedFile($event)"
        (uploadProgress)="onDropzoneUploadProgress($event)"

    ><div class="dropzone-content">
        <input #fileInput type="file" id="picture" name="picture" accept="image/*" capture="environment" hidden (change)="onFileSelected($event)" />
    </div>
        <!--(change)="onFileSelected($event)-->
    </dropzone>
        <button app-button class="mobilePhotoButton" type="button" (click)="triggerFileInput()">
            <fa-icon icon="camera"></fa-icon>
        </button>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button Color="cancel" app-button matDialogClose>Abbrechen</button>
    <button app-button (click)="CloseAndSave()">Speichern</button>
</mat-dialog-actions>
